import { render, staticRenderFns } from "./review-radio-stats.vue?vue&type=template&id=6a483ef7&"
import script from "./review-radio-stats.vue?vue&type=script&lang=js&"
export * from "./review-radio-stats.vue?vue&type=script&lang=js&"
import style0 from "./review-radio-stats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a483ef7')) {
      api.createRecord('6a483ef7', component.options)
    } else {
      api.reload('6a483ef7', component.options)
    }
    module.hot.accept("./review-radio-stats.vue?vue&type=template&id=6a483ef7&", function () {
      api.rerender('6a483ef7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/product/review-radio-stats.vue"
export default component.exports